import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useSession } from '../features/session/useSession';
import { hasPermission } from '../lib/permissions';

export interface ProtectedRouteProps {
  /** Required permission code(s). Prefer over legacy `role`. */
  permission?: string | string[];
  /** @deprecated Use `permission`. Kept for gradual migration. */
  role?: string | string[];
  children: ReactNode;
}

export function ProtectedRoute({ permission, children }: ProtectedRouteProps) {
  const { me, loading } = useSession();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!me) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  if (!hasPermission(me.permissions, permission)) {
    return <Navigate to="/404" replace />;
  }

  return children;
}
